import axios, { AxiosResponse } from 'axios';
import { auth } from '@/lib/firebase';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

const indexApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

indexApi.interceptors.request.use(async (config) => {
  if (auth.currentUser) {
    try {
      const token = await auth.currentUser.getIdToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('Error getting Firebase token:', error);
    }
  }
  return config;
});

export type LiveSignalData = {
  active_audits: number;
  queued: number;
  avg_latency_ms: number;
  last_event: string | null;
};

type LiveSignalResponse = { status: string } & LiveSignalData;

export async function getLiveSignal(): Promise<LiveSignalData> {
  const response: AxiosResponse<LiveSignalResponse> = await indexApi.get('/api/index/live-signal');
  if (response.data.status !== 'success') {
    throw new Error('Failed to load live signal');
  }
  return {
    active_audits: response.data.active_audits,
    queued: response.data.queued,
    avg_latency_ms: response.data.avg_latency_ms,
    last_event: response.data.last_event,
  };
}

export type EnterpriseInquiryPayload = {
  name: string;
  organization: string;
  email: string;
  seat_estimate?: string;
  message?: string;
};

export async function submitEnterpriseInquiry(payload: EnterpriseInquiryPayload): Promise<void> {
  const response = await indexApi.post('/api/enterprise/inquiry', payload);
  if (response.data.status !== 'success') {
    throw new Error('Failed to submit inquiry');
  }
}
